export const aoi_survey_fields = ["chacarita"];
